module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[61]426.38850b9.woff2";